import api from '@/api';

class PropertyAssessment {
  /**
   * @returns {AxiosPromise<any>}
   */
  static find(propertyId) {
    return api.get(`/properties/${propertyId}`);
  }
  /**
   * Index / Get listing of properties
   * @returns {*}
   */
  static list(propertyId) {
    return api.get(`/properties/${propertyId}/assessments`);
  }

  /**
   * Delete a property file
   * @returns {*}
   */
  static getDownloadLatestReportUrl(propertyId, propertyAssessmentId) {
    return api.defaults.baseURL + `/properties/${propertyId}/assessments/${propertyAssessmentId}/download`;
  }

  /**
   * Download a snapshot report
   * @returns {*}
   */
  static getDownloadSnapshotReportUrl(propertyId, propertyAssessmentId) {
    return api.defaults.baseURL + `/properties/${propertyId}/assessments/${propertyAssessmentId}/download-snapshot`;
  }

  /**
   * Download a snapshot report
   * @returns {*}
   */
  static getDownloadSection156ReportUrl(propertyId, propertyAssessmentId) {
    return api.defaults.baseURL + `/properties/${propertyId}/assessments/${propertyAssessmentId}/download-section-156-report`;
  }

  static getPhotos(propertyId, propertyAssessmentId) {
    return api.get(`/properties/${propertyId}/assessments/${propertyAssessmentId}/photos`);
  }
}

export default PropertyAssessment;
